<template>
    <date-time-label
        :value="now"
        :format="format"
    />
</template>

<script>
import { getNow } from '@/services/dateTime/datetimeService';
import { formats } from '@/constants/localizer';

export default {
  props: {
    format: {
      type: [Object, String],
      default: () => formats.CLOCK_FOOTER,
    },
  },
  data() {
    return {
      now: getNow(),
    };
  },
  created() {
    this.interval = setInterval(() => {
      this.now = getNow();
    }, 1000);
  },
  destroyed() {
    clearInterval(this.interval);
  },
};
</script>
